module.exports = __webpack_public_path__ + "media/images/mailer/flag-48-primary-9f91279ba2f1dd91fc6fac1570ca36df.png";